import Link from "next/link";
import { FullWidthImage, FullWidthImageDimsProps } from "~/ui-library";

export type FullWidthImageBlockProps = {
  linkHref: string | null;
} & FullWidthImageDimsProps;

export const FullWidthImageBlock = ({
  linkHref,
  ...fullWidthImageProps
}: FullWidthImageBlockProps) => {
  if (linkHref) {
    return (
      <Link href={linkHref} className="mb-m block">
        <FullWidthImage {...fullWidthImageProps} />
      </Link>
    );
  }
  return <FullWidthImage {...fullWidthImageProps} className="mb-m" />;
};
